'use client';

import { Button } from '@ahafood/ui/components/button';
import { AhafoodLogo } from '@ahamove/icons/order';
import { cn } from '@ahm/common-helpers';
import { ArrowLeft } from 'lucide-react';
import { useCityRoutes } from '@/hooks/use-city-navigation';
import { useRouter } from '@/i18n/routing';

export function DesktopHeader() {
  const routes = useCityRoutes();
  const router = useRouter();
  const handleBack = () => {
    const prevUrl = document.referrer || '';
    const isSameOrigin = prevUrl.startsWith(window.location.origin);
    const isRedirectFromStore = prevUrl.includes('/store/');

    if (!prevUrl || window.history.length <= 1) {
      router.push(routes.home);
      return;
    }

    if (isSameOrigin && !isRedirectFromStore) {
      router.back();
    } else {
      router.push(routes.home);
    }
  };
  return (
    <header
      className={cn(
        'sticky top-0 z-50 w-full md:block hidden',
        'bg-background/90 shadow-4'
      )}
    >
      <div className="mx-auto flex flex-row w-full md:h-20 h-16 max-w-screen-xl items-center px-4">
        <Button
          onClick={handleBack}
          variant="link"
          size="lg"
          className="-ml-4 px-4 text-xl font-bold text-neutral-60 hover:text-neutral-90 md:h-16 md:space-x-2 [&_svg]:size-6"
        >
          <ArrowLeft />
          <span className="hidden md:inline-block">Quay lại</span>
        </Button>
        <AhafoodLogo className="h-10 w-full md:mr-[150px] mr-11" />
      </div>
    </header>
  );
}
